import React, { useContext } from 'react'

import Icon from 'components/Icon'
import AppHeaderUserNav from 'components/AppHeader/AppHeaderUserNav/AppHeaderUserNav'
import { AppHeaderContext } from 'components/AppHeader/AppHeader'

import './app-header-desktop-user-nav.pcss'

const AppHeaderDesktopUserNav = () => {
    const { currentUser } = useContext(AppHeaderContext)

    return (
        <AppHeaderUserNav
            className="app-header-desktop-user-nav"
            renderButton={() => (
                <div className="app-header-desktop-user-nav__button">
                    <Icon
                        name="icon_user_white"
                        size="m"
                        forceSize
                        color="white"
                    />
                    <div className="app-header-desktop-user-nav__button-text">{currentUser.me.user.firstName}</div>
                </div>
            )}
        />
    )
}

export default AppHeaderDesktopUserNav
